<div class="back-to-list">
  <div class="navigation-left">
    <a class="arrow arrow-left" (click)="goBack()">{{ backToLabel }}</a>
  </div>
</div>

<mat-card>
  <mat-card-title>
    <span>
      {{ 'add-account/google-business-profile/login/title' | translate }}
    </span>
  </mat-card-title>
  <mat-card-subtitle>
    <span>
      {{ 'add-account/google-business-profile/login/subtitle' | translate }}
    </span>
  </mat-card-subtitle>
  <mat-card-content>
    <div class="connection-modes">
      <div class="connection-mode">
        <button mat-raised-button color="primary" (click)="useGoogleAccount()">
          <span>{{
            'add-account/google-business-profile/login/use/button'
              | translate: { email: googleAccountAttachedToAlcmeon?.email }
          }}</span>
        </button>
        <div
          class="description"
          [innerHTML]="'add-account/google-business-profile/login/use/description' | translate"></div>
      </div>

      <strong class="separator" translate="OR"></strong>

      <div class="connection-mode">
        <button mat-raised-button (click)="connectGoogleAccount()">
          <span>{{ 'add-account/google-business-profile/login/connect-another-account/button' | translate }}</span>
          &nbsp;
          <img src="assets/img/google-business-profile.png" alt="Logo Google" />
        </button>
        <div
          class="description"
          [innerHTML]="
            'add-account/google-business-profile/login/connect-another-account/description'
              | translate: { email: googleAccountAttachedToAlcmeon?.email }
          "></div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
